import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import * as utils from "@/utils";
import store from "./vuex";
import routerPlugin from "./plugins/router";
import { intApp } from "./ingeekJsApi";
import VueHead from "vue-head";
import VueI18n from "vue-i18n";
import DebugLog from "./utils/log";
import en from "./locales/en";
import zh from "./locales/zh";
import IngeekJSAPI from "@/assets/js/ingeek-jsapi/index";
Vue.use(VueI18n);
Vue.use(VueHead);
import "./assets/js/vwjsbridge-v1.0.0.js";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload);
import "@/assets/scss/common-style.scss";
import env from "./utils/env";
const urlParams = new URLSearchParams(window.location.search);
export const i18n = new VueI18n({
  locale: !urlParams.get("language")
    ? "zh"
    : ["zh_CN", "zh"].includes(urlParams.get("language") || "")
    ? "zh"
    : "en", // 设置默认语言
  fallbackLocale: "en", // 设置备用语言
  messages: {
    en,
    zh,
  },
});
(window as any).webViewJavascriptBridge.init({
  key: "SVW-MOS-Ingeek",
})
Vue.config.productionTip = false;
Vue.prototype.$util = utils;
Vue.prototype.$IngeekJSAPI = IngeekJSAPI;
Vue.prototype.$Logger = DebugLog;

Vue.prototype.$axios = axios;
Vue.config.errorHandler = function (err, vm, info) {
  DebugLog.info(err, info);
  console.log(err, info);
};
routerPlugin.install(Vue, {
  canUseNewWebView: false,
  newWebViewOptions: {},
  moduleName: "",
  store,
  router,
});
const renderVueApp = () => {
  new Vue({
    store,
    router,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
};
intApp().then(() => {
  DebugLog.info({ key: "---获取用户ENV环境---", env });
  renderVueApp();
});
